import { Tag } from "@brg/api";

export const extractTagChilds = (arr: any) => {
    const result: Tag<'Local'>[] = [];
    arr?.map((i: any) => {
      i?.additionalTags?.forEach((k: any) => result?.push(k))
    })

    return result;
  }
import { Tag } from "@brg/api";

export const extractTagChilds = (arr: any) => {
    const result: Tag<'Local'>[] = [];
    arr?.map((i: any) => {
      i?.additionalTags?.forEach((k: any) => result?.push(k))
    })

    return result;
  }
